import {
  doGetFetch,
  doPutFetch,
  doPostFetch,
  doGetFetchData,
  doPutFetchResponse,
} from './utils/fetchUtil';
import { getPageConfigInfo } from './commonDataService';
import {
  CART_ITEM,
  POST_QUOTE,
  GET_QUOTE,
  GET_PROMO,
  APPLY_PROMO,
  GET_XSELL_ITEMS,
  GET_MISCDATA,
  GET_ORDER_FORM,
  UPDATE_ORDER_FORM,
  CART_PUT,
  SHIPPING_PUT,
  ADDR_STANDARDIZATION,
  BILLING_INFO_PUT,
  GET_SAFE_TECH,
  GET_SHIPPING_SPEED,
  GET_ORDER_DATA,
  POST_SURVEY_DATA,
  GET_RPS_VALIDATION,
  GET_ORDER_HISTORY_LIST,
  COMBINED_FDS_POST,
} from './config/url';

export function getCartItem() {
  return doGetFetch(CART_ITEM);
}

export function putCartItem(params, successCallBack, errorCallBack) {
  return doPutFetch(CART_ITEM, params, null)
    .then(() => {
      getPageConfigInfo(successCallBack, errorCallBack);
    })
    .catch((err) => {
      if (errorCallBack) errorCallBack(`checkoutDataService -> addToCart failed. Error: ${err}`);
      console.log('Add to cart Issue:', 'error');
    });
}

export function postQuoteDetails(data) {
  let requestUrl = POST_QUOTE.url.replace('{state}', data.state);
  requestUrl = requestUrl.replace('{zip}', data.zip);
  requestUrl = requestUrl.replace('{taxCall}', data.taxCall);
  const quoteData = data.quoteModel;
  return doPostFetch({ url: requestUrl }, quoteData);
}

export function getQuoteDetails() {
  return doGetFetchData(GET_QUOTE);
}

export function getPromoData(data) {
  const requestUrl = GET_PROMO.url.replace('{pfids}', data);
  return doGetFetchData({ url: requestUrl });
}

export function applyPromoCode(data) {
  let requestUrl = APPLY_PROMO.url.replace('{source}', data.source);
  requestUrl = requestUrl.replace('{pfids}', data.pfids);
  return doGetFetchData({ url: requestUrl });
}

export function getXsellProducts(searchQuery) {
  return doGetFetch(GET_XSELL_ITEMS, searchQuery, '&');
}

export function getMiscData(searchQuery) {
  return doGetFetch(GET_MISCDATA, searchQuery, '&');
}

export function getOrderForm() {
  return doGetFetch(GET_ORDER_FORM);
}

export function updateOrderForm(params) {
  return doPutFetch(UPDATE_ORDER_FORM, params);
}

export function addToCartPut(params, successCallBack, errorCallBack, hadQueryParam) {
  let requestUrl = CART_PUT.url;

  if (hadQueryParam) {
    requestUrl = `${requestUrl}?reorder=2`;
  }

  doPutFetch({ url: requestUrl }, params, null)
    .then(() => {
      getPageConfigInfo(successCallBack, errorCallBack);
    })
    .catch((err) => {
      if (errorCallBack) errorCallBack(`checkoutDataService -> addToCart failed. Error: ${err}`);
      console.log('Add to cart Issue:', 'error');
    });
}

// New function which passes order form shopper id while adding product to cart - currently being used only for Deposit slips in RR flow
export function addToCartPutRRFlow(params, successCallBack, errorCallBack, shopperId) {
  let requestUrl = CART_PUT.url;

  if (shopperId) {
    // pass shopper id as null so that correct value will be fetched from cookie in the api
    requestUrl = `${requestUrl}?shopperId=&orderFormShopperId=${shopperId}`;
  }

  doPutFetch({ url: requestUrl }, params, null)
    .then(() => {
      getPageConfigInfo(successCallBack, errorCallBack);
    })
    .catch((err) => {
      if (errorCallBack)
        errorCallBack(`checkoutDataService -> addToCartPutRRFlow failed. Error: ${err}`);
      console.log('Add to cart Issue:', 'error');
    });
}

export function putShippingDetails(data) {
  const requestUrl = SHIPPING_PUT.url;
  const shippingData = data;
  return doPutFetch({ url: requestUrl }, shippingData);
}

export function addressStandardization(data) {
  const requestUrl = ADDR_STANDARDIZATION.url;
  return doPostFetch({ url: requestUrl }, data);
}

export function putBillingInfo(data) {
  const requestUrl = BILLING_INFO_PUT.url;
  return doPutFetch({ url: requestUrl }, data);
}

export function getSafeTech() {
  return doGetFetch(GET_SAFE_TECH);
}

export function getShippingSpeed(data) {
  const requestUrl = GET_SHIPPING_SPEED.url;
  return doPostFetch({ url: requestUrl }, data);
}

export function getOrderData(orderNum) {
  const requestUrl = GET_ORDER_DATA.url.replace('{orderNumber}', orderNum);
  return doGetFetchData({ url: requestUrl });
}

export function submitSurveyFeedback(data) {
  const requestUrl = POST_SURVEY_DATA.url;
  return doPostFetch({ url: requestUrl }, data);
}

const validateRPS = function () {
  return doGetFetch(GET_RPS_VALIDATION);
};

export function getRPSStatus() {
  return validateRPS()
    .then(function (RPSStatus) {
      return RPSStatus;
    })
    .catch(function (ex) {
      console.log(ex);
      return 'NotScreened';
    });
}

export function putOrderReview(data) {
  return doPutFetchResponse(GET_ORDER_HISTORY_LIST, data);
}
export function postCombinedFds(data) {
  const requestUrl = COMBINED_FDS_POST.url;
  return doPostFetch({ url: requestUrl }, data);
}
